<span class="copy-span">
  <span #content (click)="copyBtn.copy()">
    <ng-content></ng-content>
  </span>
  <lib-copy-button [small]="true" [content]="textContent()" #copyBtn></lib-copy-button>
</span>
